


















# Lib autocomplete https://github.com/paliari/v-autocomplete
item = require './contact_item.vue'
helpers = require '../../../helpers.coffee'
on_clickaway = require('vue-clickaway')

view_model = {
  mixins: [ on_clickaway.mixin ]
  props:
    external_id:
      default: ''

    from_dialer:
      default: false

  data : ->
    show: false
    current_company: Session.current_company
    current_user: Session.current_user
    contact: null
    contacts: []
    show_no_result_found_message: false
    item_contact: item
    loading: false
    attrs: {
      placeholder: @$t('contacts.label.searchContact')
    }

  methods:
    selectCategory: (category) ->
      @category_selected = category
      @show_categories = false
      @searchTemplates("") if @category_selected

    hideCategories: ->
      @show_categories = false

    toggleCategories: ->
      @show_categories = !@show_categories

    setFocus: ->
      jQuery('#'+@id+'.v-autocomplete .v-autocomplete-input').focus()

    onClickaway: ->
      @$emit 'hide'

    splitPhones: (contacts) ->
      new_contacts = []
      for contact in contacts
        if contact.telephone && contact.cellphone
          new_contact = new Contact(contact)
          new_contact.telephone = null
          contact.cellphone = null
          new_contacts.push new_contact
      contacts.concat(new_contacts)

    removePhones: (contacts) ->
      for contact in contacts
        if contact.telephone || contact.cellphone
          contact.telephone = null
          contact.cellphone = null
      contacts

    getLabel: (contact) ->
      contact?.full_name

    searchContacts: (text) ->
      @loading = true
      if @from_dialer
        @contact_resources.index @searchSuccess, @unknownError, params: {q: { search_phone_query: text, user_id_eq: @current_user.id, not_blocklisted_status: true }, per: 10 }
      else
        @contact_resources.index @searchSuccess, @unknownError, params: {q: { search_query: text, user_id_eq: @current_user.id, not_blocklisted_status: true }, per: 10 }

    searchSuccess: (resources) ->
      @loading = false
      if @from_dialer
        @contacts = @splitPhones(resources.contacts)
      else
        @contacts = @removePhones(resources.contacts)

      if resources.contacts.length == 0
        @show_no_result_found_message = true
        setTimeout((=> @show_no_result_found_message = false), 3000) # Hidding the message after 3 seconds
      else
        @show_no_result_found_message = false

    addContact: (contact) ->
      @$emit 'contact-selected', contact

  computed:
    id: ->
      "contact_autocomplete_"+@external_id

  mounted: ->
    @setFocus()

  created: ->
    @contact_resources = new ContactsResource @current_company.id
}
exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/autocomplete/contacts.vue